module.exports = __webpack_public_path__ + "img/bybit.0ecd02dd.png";